<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="50%">
      <v-card class="custom-font-regular">
        <v-card-title class="custom-font-size grey lighten-2" primary-title>
          Definición del artículo {{ criterio.articulo }} según {{ criterio.reglamento }}
        </v-card-title>
        <v-card-text class="instructivo">{{ criterio.instructivo }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    criterio: Object
  },

  data () {
    return {
      dialog: false
    }
  },

  methods: {
    openDialog () {
      this.dialog = true
    }
  }
}
</script>

<style scoped>
.custom-font-regular {
  font-family: SourceSansProRegular, sans-serif;
}
.custom-font-size {
  font-size: 1.5em;
}
.instructivo {
  white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
  white-space: -pre-wrap; /* Opera */
  white-space: -o-pre-wrap; /* Opera */
  white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
  word-wrap: break-word; /* IE 5.5+ */
  width: 100%;
}
</style>
